import {theme} from "../../utils";

export
const styles = {
    footerBtnWrapper: {
        borderRadius: "8px",
        textTransform: "capitalize",
        height: "38px",
        minWidth: "197px",
        width: 'auto'
    },
    textBorder: {
        p: "21px 25px 28px 23px",
        mt: "20px",
        borderRadius: "16px",
        backgroundColor: "#F8F8F8"
    },
    leavingLabel: {
        fontFamily: "Poppins",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "var(--font-size-xs)",
        lineHeight: "100%",
        letterSpacing: "0px",
        textAlign: "center",
        color: "#484A4C",
        mt: "20px"
    },
    infoMsgLabel: {
        ...theme.typography.poppinsBodyRegular,
        fontSize: "14px",
        textAlign: "left",
        lineHeight: "24px",
        letterSpacing: '-.4px',
    },
    containedText: {
        ...theme.typography.montseratH1,
        fontSize: "13.96px",
        letterSpacing: "-1.5%",
        lineHeight: "100%",
        color: "#fff",
        textDecoration: "underline",
        textDecorationColor: "#fff",
    }
}

export interface IRedirectDialogProps {
    onCloseRedirectDialog?: () => void;
    showDialog: boolean;
    vendorItem: any;
}